import { CREATE_CHALLENGE } from "shared/api";
import { Page, SubmitButton, useNavigator } from "shared/react";
import { callAPI } from "../util/api.js";
import { ChallengeForm } from "./ChallengeForm.js";
import { CreatorAssertion } from "./CreatorAssertion.js";
import { useCreatorContext } from "./CreatorContext.js";

export function ChallengeCreatePage(): React.ReactElement {
	const creator = useCreatorContext();
	const nav = useNavigator();
	return (
		<Page title="Create challenge">
			<CreatorAssertion creator={creator} />
			<header>
				<h1>Create challenge</h1>
			</header>
			<section>
				<ChallengeForm
					onSubmit={async v => {
						const id = await callAPI(CREATE_CHALLENGE, v);
						nav.redirect(`/challenge/${id}`);
					}}
					data={{ creator }}
				>
					<SubmitButton>Create challenge</SubmitButton>
				</ChallengeForm>
			</section>
		</Page>
	);
}
